import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/companies';
const filter = (filter) => (filter) ? '?filter=' + filter : '';
const state = {
    companies: [],
    company: null,
};
const getters = {
    companies: (state) => state.companies,
    company: (state) => state.company    
};
const actions = {
    /**
     * @todo: remove see /views/delme.OfferCreateDebug.vue
     */
    async fetchCompanies({ commit }, search) {
        const response = await axios.get(API_URL +  filter(search));
        commit('setCompanies', response.data.items);
    },
    async fetchCompany({ commit }, id) {
        const response = await axios.get(API_URL + '/' + id + '/by-ref')
        commit('setCompany', response.data);
    }
};
const mutations = {
    setCompanies: (state, companies) => state.companies = companies,
    setCompany: (state, company) => state.company = company,
};

export default {
    state,
    getters,
    actions,
    mutations,
}